import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.018 32.604 38.311 13.31c.943-.943 2.357.471 1.414 1.414l-20 20c-.328.328-.713.37-1.036.247a1.1 1.1 0 0 1-.447-.276c-.27-.297-.485-.524-.643-.683l-9.288-9.288c-.943-.943.471-2.357 1.414-1.414l9.293 9.293Z",
      clipRule: "evenodd"
    }
  )
);
var SvgTickOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TickOutlined_default = SvgTickOutlined;

export { TickOutlined_default as default };
